module.exports = __webpack_public_path__ + "6548c0bd7995576358bda9da38e8d920.png";